<script>
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [
            bemMixin('btn'),
        ],
        props: {
            tag: {
                type: String,
                default: 'button',
            },
        },
        computed: {
            rootClasses() {
                const { bemFacets, bemRoot } = this;

                return [bemRoot, ...bemFacets];
            },
        },

        methods: {
            /**
             * Check if a vnode is supported by this component
             * @param {object} componentOptions - Vue component options
             * @param {string} tag - The vnode's tag name if applicable
             * @param {string} text - The vnode's text if applicable
             * @return {boolean} The check's result
             */
            isSupportedNodeType({ componentOptions, tag, text }) {
                const isSimpleNode = !componentOptions && (tag || text);
                const isBaseIconComponent = componentOptions && componentOptions.tag === 'base-icon';

                if (isSimpleNode || isBaseIconComponent) {
                    return true;
                }

                return false;
            },
            /**
             * Wrap a vnode in a div with class `btn--text` or `btn--icon`
             * @param {function} createElement - The creation method
             * @param {object} child - A vnode
             * @return {object} A new dom element
             */

            createButtonChild(createElement, child) {
                if (child.isComment) {
                    return child;
                }

                if (!this.isSupportedNodeType(child)) {
                    this.$log.warn('Node type not supported - Please use a custom component for more complex use cases!', child);
                }

                const children = [child.text || child];
                const props = {
                    class: `${ this.bemRoot }--${ child.text ? 'text' : 'icon' }`,
                };

                return createElement('div', props, children);
            },
            /**
             * Wrap slot children into a enclosing div
             * @example `<div class='btn--text'>{child}</div>`
             * @param {function} createElement - The creation method
             * @return {object} A new dom element
             */
            createButtonContent(createElement) {
                const children = this.$slots.default.map(child => this.createButtonChild(createElement, child));
                const props = {
                    class: `${ this.bemRoot }--wrap`,
                };

                return createElement('div', props, children);
            },
        },
        render(createElement) {
            const children = [this.createButtonContent(createElement)];
            const props = {
                class: this.rootClasses,
                attrs: this.$attrs,
            };

            return createElement(this.tag, props, children);
        },
    };
</script>
